import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import './styles.css';
import { sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';
import { useNavigate } from 'react-router-dom';


const ModalAtendimentoEncerrado: React.FC<{showModal: boolean; handleShowModal: () => void;}> = ({ showModal, handleShowModal }) => {

    const navigate = useNavigate();

    const closeModal = () => {
        handleShowModal();
        navigate('/home');
    }

    return (
        <div>
            <Modal
                open={showModal}
                onClose={closeModal}
            >
                <div className='container-schedule-modal' >
                    <IconButton
                        aria-label="Fechar"
                        onClick={closeModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <Typography sx={sxTypographyTitleModal}>Encerrado</Typography>
                        <Typography sx={sxTypographySubTitleModal}>Seu atendimento foi encerrado com sucesso!</Typography>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ModalAtendimentoEncerrado;
